/**
 * announcement
 */

const announcement = {
    cfg:  {
        name: 'announcement',
        infoBox: document.querySelector('.js-announcement'),
        closeBtn: document.querySelector('#js-infoboxClose'),
    },

    closeBox() {
        sessionStorage.setItem('infobox', 'hidden');
        this.cfg.infoBox.classList.add('hidden');
    },

    getVar() {

    },

    init() {
        if (this.cfg.infoBox) {
            this.cfg.closeBtn.addEventListener('click', () => {
                this.closeBox();
            });

            const cookie = sessionStorage.getItem('infobox');

            if (cookie !== null) {
                this.cfg.infoBox.classList.add('hidden');
            }

            const now = new Date();
            const from = new Date(this.cfg.infoBox.dataset.from);
            const to = new Date(this.cfg.infoBox.dataset.to);

            if (now >= to || now <= from) {
                this.cfg.infoBox.classList.add('hidden');
            }

            document.addEventListener('click', (e) => {
                let targetElement = e.target;

                do {
                    if (targetElement === this.cfg.navWrapper || targetElement === this.cfg.navBarToggle) {
                        return;
                    }
                    // Go up the DOM
                    targetElement = targetElement.parentNode;
                } while (targetElement);

                if (!this.cfg.infoBox.classList.contains('hidden')) {
                    this.closeBox();
                }
            });
        }
    }
};

export default announcement;



// WEBPACK FOOTER //
// ./___src/templates/_atoms/announcement/_script.js